import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'angie-pagination',
	templateUrl: './pagination.component.html',
	styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent {
	@Input() hasPrevious: boolean = false;
	@Input() hasNext: boolean = false;
	@Output() pageChange: EventEmitter<number> = new EventEmitter<number>();
	@Input() set page(page: number) {
		if (!!page) {
			if (page === 1) {
				this.hasPrevious = false;
			}
			this._page = page;
		}
	}
	get page(): number {
		return this._page;
	}
	private _page: number = 1;

	nextPage(): void {
		if (!this.hasNext) {
			return;
		}

		this.page++;
		this.hasPrevious = true;
		this.pageChange.emit(this.page);
	}

	previousPage(): void {
		if (!this.hasPrevious) {
			return;
		}

		this.page--;
		this.pageChange.emit(this.page);
	}
}
